import './tarjetas.css';
import { FC_targetas } from 'views/Tagetas/functions';
import { useT } from 'i18n';

const claseEstado = (s) => {
  const t = String(s || '').toUpperCase();
  if (t.includes('APROB')) return 'e-aprobado';
  if (t.includes('RECHAZ')) return 'e-rechazado';
  if (t.includes('REVIS')) return 'e-revision';
  return 'e-proceso';
};

const numeroVisible = (n) => {
  if (!n) return null;
  const f = FC_targetas.formatCardNumber(String(n));
  return f.startsWith('Invalid') ? null : f.replace(/(.{4})/g, '$1 ').trim();
};

const ListaTarjetas = ({ tarjetas, onAgregar, onDetalles, onExportar, onDesactivar }) => {
  const { t, ts } = useT();
  if (!tarjetas.length) {
    return (
      <div className="p7t-vacio">
        <h3>{t('tarjeta.sinTarjetas')}</h3>
        <p>{t('tarjeta.sinTarjetasAyuda')}</p>
        <button type="button" className="p7-btn-gold" onClick={onAgregar}>{t('tarjeta.solicitar')}</button>
      </div>
    );
  }

  return (
    <>
      <div className="p7t-cab">
        <h2>{t('tarjeta.misTarjetas')}</h2>
        <button type="button" className="p7-btn-gold" onClick={onAgregar}>{t('tarjeta.solicitarOtra')}</button>
      </div>
      <div className="p7t-grid">
        {tarjetas.map((tar) => {
          const num = numeroVisible(tar.number);
          const nombre = [tar.first_name, tar.last_name].filter(Boolean).join(' ');
          const emitida = !!num;
          const tieneMov = tar.movimientos && tar.movimientos.length > 0;
          return (
            <div className="p7t-item" key={tar.id}>
              <div className={`p7t-cara ${emitida ? '' : 'pendiente'}`}>
                <div className="p7t-top">
                  <span className="p7t-marca">PANTHER7</span>
                  <span className="p7t-visa">{tar.card_model || 'VISA'}</span>
                </div>
                <div className={`p7t-num ${emitida ? '' : 'vacio'}`}>
                  {emitida ? num : t('tarjeta.numDisponible')}
                </div>
                <div className="p7t-pie">
                  <div className="p7t-titular"><small>{t('tarjeta.titular')}</small>{nombre || t('tarjeta.sinNombre')}</div>
                  <span className={`p7t-chip-estado ${claseEstado(tar.status)}`}>{ts(tar.status) || t('tarjeta.enProceso')}</span>
                </div>
              </div>
              <div className="p7t-info">
                <div className="p7t-saldo"><small>{t('tarjeta.saldo')}</small><strong>{Number(tar.balance || 0).toFixed(2)} USDT</strong></div>
                <div className="p7t-acciones">
                  {emitida && <button type="button" className="p7t-btn" onClick={() => onDetalles(tar.id)}>{t('tarjeta.detalles')}</button>}
                  {tieneMov && <button type="button" className="p7t-btn" onClick={() => onExportar(tar.id)}>{t('tarjeta.descargarMov')}</button>}
                  <button type="button" className="p7t-btn peligro" onClick={() => onDesactivar(tar.id)}>
                    {emitida ? t('tarjeta.desactivar') : t('tarjeta.cancelarSolicitud')}
                  </button>
                </div>
              </div>
              {!emitida && <div className="p7t-nota">{t('tarjeta.notaRevision')}</div>}
            </div>
          );
        })}
      </div>
    </>
  );
};

export default ListaTarjetas;
